import { Reducer } from 'redux';
import { MachineMaintenance } from "models/MachineMaintenance";
import { IMachineMaintenanceActions, MachineMaintenanceActionType } from "redux/actions/settings/MachineMaintenanceActions";

const initialState: MachineMaintenance[] | null = null;
export const machineMaintenancesReducer: Reducer<MachineMaintenance[] | null, IMachineMaintenanceActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case MachineMaintenanceActionType.FETCH_MACHINEMAINTENANCES_SUCCESS:
                {
                    return action.returnPayload as MachineMaintenance[];
                }
            case MachineMaintenanceActionType.ADD_MACHINEMAINTENANCE_SUCCESS:
                {
                    let newMachineMaintenances = [...state!];
                    newMachineMaintenances.push({ ...action.returnPayload } as MachineMaintenance)
                    return newMachineMaintenances;
                }
            case MachineMaintenanceActionType.EDIT_MACHINEMAINTENANCE_SUCCESS:
            case MachineMaintenanceActionType.DELETE_MACHINEMAINTENANCE_SUCCESS:
                {
                    let newManufs = [...state!];
                    const updatedMachineMaintenance = { ...action.returnPayload } as MachineMaintenance;
                    newManufs = newManufs.map(nm => nm.id === updatedMachineMaintenance.id ? updatedMachineMaintenance : nm);
                    return newManufs;
                }
            default:
                return state;
        }
    };
